import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, ImageUploadWithPreview } from 'src/components';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchSetting } from 'src/redux/action/setting.action';
import { IoIosClose } from 'react-icons/io';
import { fetchDetails } from 'src/redux/action/details.action';
import Loader from 'src/components/loader';

interface IProps {
  socialLinks?: any;
  loading?: boolean;
}

const FORM_VALIDATION = Yup.object().shape({
  facebook: Yup.object().shape({
    url: Yup.string().url('Invalid Link format'),
  }),
  instagram: Yup.object().shape({
    url: Yup.string().url('Invalid Link format'),
  }),
});
const SocailMedia: React.FC<IProps> = ({ socialLinks, loading }) => {
  const [isFacebookChecked, setIsFacebookChecked] = useState<any>(false);
  const [isInstagramChecked, setIsInstagramChecked] = useState<any>(false);
  const [isWhatsappChecked, setIsWhatsappChecked] = useState<any>(false);
  useEffect(() => {
    setIsFacebookChecked(
      socialLinks && socialLinks?.facebook?.showInCustomerApp
    );
    setIsInstagramChecked(
      socialLinks && socialLinks?.instagram?.showInCustomerApp
    );
    setIsWhatsappChecked(
      socialLinks && socialLinks?.whatsapp?.showInCustomerApp
    );
  }, [socialLinks]);

  const dispatch = useDispatch();
  const initValues = {
    facebook: {
      url: socialLinks ? socialLinks?.facebook?.url : '',
      showInCustomerApp: isFacebookChecked,
    },
    instagram: {
      url: socialLinks ? socialLinks?.instagram?.url : '',
      showInCustomerApp: isInstagramChecked,
    },
    whatsapp: {
      url: socialLinks ? socialLinks?.whatsapp?.url : '',
      showInCustomerApp: isWhatsappChecked,
    },
  };

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const payload = {
      socialLinks: {
        facebook: {
          url: values?.facebook?.url,
          showInCustomerApp: isFacebookChecked,
        },
        instagram: {
          url: values?.instagram?.url,
          showInCustomerApp: isInstagramChecked,
        },
        whatsapp: {
          url: values?.whatsapp?.url,
          showInCustomerApp: isWhatsappChecked,
        },
      },
    };
    try {
      await Service.post('/settings/update', payload);
      toastAlert('success', `Social Links are successfully updated`);
      dispatch(fetchSetting() as any);
      dispatch(fetchDetails() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={initValues}
          validateOnMount
          onSubmit={handleSubmit}
          validationSchema={FORM_VALIDATION}
        >
          {({ isSubmitting, isValid, values }) => (
            <Form className="mt-4">
              <>
                <div className="relative"></div>
                <div className="mb-5">
                  <TextField label={'Facebook Link'} name="facebook.url" />
                  <div className="-mt-2 flex items-center justify-between">
                    <p className="text-sm text-secondary-0">
                      Enable in Contactless app
                    </p>
                    <div className="flex items-center justify-between ">
                      <label
                        htmlFor="facebook"
                        className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
                      >
                        <div
                          className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-700 ${
                            isFacebookChecked
                              ? 'transform translate-x-full bg-primary'
                              : ''
                          }`}
                        ></div>
                        <input
                          disabled={!values?.facebook?.url}
                          type="checkbox"
                          id="facebook"
                          name="facebook.showInCustomerApp"
                          className="hidden"
                          checked={isFacebookChecked}
                          onChange={() => {
                            setIsFacebookChecked(!isFacebookChecked);
                            setIsWhatsappChecked(false);
                            setIsInstagramChecked(false);
                          }}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <TextField label={'Instagram Link'} name="instagram.url" />
                  <div className="-mt-2 flex items-center justify-between">
                    <p className="text-sm text-secondary-0">
                      Enable in Contactless app
                    </p>
                    <div className="flex items-center justify-between ">
                      <label
                        htmlFor="instagram"
                        className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
                      >
                        <div
                          className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-700 ${
                            isInstagramChecked
                              ? 'transform translate-x-full bg-primary'
                              : ''
                          }`}
                        ></div>
                        <input
                          disabled={!values?.instagram?.url}
                          type="checkbox"
                          id="instagram"
                          name="instagram.showInCustomerApp"
                          className="hidden"
                          checked={isInstagramChecked}
                          onChange={() => {
                            setIsInstagramChecked(!isInstagramChecked);
                            setIsFacebookChecked(false);
                            setIsWhatsappChecked(false);
                          }}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  <TextField label={'Whatsapp Link'} name="whatsapp.url" />
                  <div className="-mt-2 flex items-center justify-between">
                    <p className="text-sm text-secondary-0">
                      Enable in Contactless app
                    </p>
                    <div className="flex items-center justify-between ">
                      <label
                        htmlFor="whatsapp"
                        className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer"
                      >
                        <div
                          className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-700 ${
                            isWhatsappChecked
                              ? 'transform translate-x-full bg-primary'
                              : ''
                          }`}
                        ></div>
                        <input
                          disabled={!values?.whatsapp?.url}
                          type="checkbox"
                          id="whatsapp"
                          name="whatsapp.showInCustomerApp"
                          className="hidden"
                          checked={isWhatsappChecked}
                          onChange={() => {
                            setIsWhatsappChecked(!isWhatsappChecked);
                            setIsInstagramChecked(false);
                            setIsFacebookChecked(false);
                          }}
                        />
                      </label>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-end my-2">
                  <Button
                    text="save details"
                    variant="primary"
                    type="submit"
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                  />
                </div>
              </>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default React.memo(SocailMedia);
